export default class UnreadCounterView {
    constructor(skin) {
        this._skin = skin;
    }

    setCounter(value) {
        if (value > 0) {
            this._skin.visible = true;            
            
            if (value > 9) {
                this._skin.gotoAndStop("2digits");
            } else {
                this._skin.gotoAndStop("1digit");
            }

            this._skin.textField.text = value > 99 ? "99+" : value;
        } else {
            this._skin.visible = false;
        }
    }
}